import { render, staticRenderFns } from "./SwPagination.vue?vue&type=template&id=79c09e5d"
import script from "./SwPagination.vue?vue&type=script&lang=js"
export * from "./SwPagination.vue?vue&type=script&lang=js"
import style0 from "./SwPagination.vue?vue&type=style&index=0&id=79c09e5d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports